import { socialLinks } from '../constants/socialLinks';

export const commonService = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  provider: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
    logo: 'https://www.boldare.com/static/logo.svg',
  },
  availableChannel: {
    '@type': 'ServiceChannel',
    serviceUrl: 'https://www.boldare.com/contact/',
    availableLanguage: [
      {
        '@type': 'Language',
        name: 'English',
      },
    ],
  },
  areaServed: 'Worldwide',
  sameAs: Object.values(socialLinks),
};
